import Tml from "../components/tml.js";
export default {
    init () {
        console.log ('init tml-action-login');
        const formLogin = new Tml('.tml-login');
        formLogin.validateForm();
    }
}
